<ion-content [fullscreen]="true">
  <div class="wrapper-form">
    <div *ngIf="!PersonFacade.submitted">
      <img class="logo" src="../../../assets/icon/radiant_Insider.png" />
      <ion-qc-person-details-form
        [personDetails]="personDetails"
      ></ion-qc-person-details-form>

      <ion-row
        ><ion-button [disabled]="PersonFacade.formIsValid" (click)="register()"
          >Υποβολή</ion-button
        ></ion-row
      >
    </div>

    <div *ngIf="PersonFacade.submitted">
      <ion-label *ngIf="PersonFacade.isDataUpdated" class="align-text">
        Το email σας υποβλήθηκε επιτυχώς!
      </ion-label>
      <ion-label *ngIf="!PersonFacade.isDataUpdated" class="align-text">
        Υπήρξε ένα πρόβλημα κατά την υποβολή του email σας.
      </ion-label>
    </div>
  </div>
</ion-content>
